export const WIDGET_ID = '144097ea-fea0-498e-ade7-e6de40127106';
//# sourceMappingURL=widget-id.js.map